<icc-list
    [items]="systems"
    itemTemplate="itemImgTitle"
    itemImgHeight="medium"
    (select)="selectSystem($event)"
    [selected]="selectedSystem$ | async"
></icc-list>
